



























































import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import EmptyData from '../../EmptyData/EmptyData.vue'
import { EntitiesListLocalData, EntityCardStructure } from '../includes/types'
import EntityCard from './EntityCard.vue'

@Component({
  components: {
    EntityCard,
    EmptyData
  }
})
export default class ListOverlay extends Vue {
  @Prop({ type: [ Function, Promise ] }) items!: EntitiesListLocalData

  @Prop() stepType!:any

  @Prop({ type: String }) entityKey!: string

  @Emit('onSelect')
  onSelect(id: EntityCardStructure['id']) {
    return id
  }

  searchQuery = ''

  data: null | Array<EntityCardStructure> = null

  get queriedData():Array<EntityCardStructure> {
    if (this.data !== null && this.data.length) {
      if (this.searchQuery.length) {
        return this.data.filter(item => item.title.toLowerCase().trim().includes(this.searchQuery.toLowerCase().trim()))
      }

      return this.data
    }

    return []
  }

  get selectEntityListHelpMessageKey():string {
    return `${ this.entityKey }_list_help_message`
  }

  get selectEntityListEmptyHelpMessageKey():string {
    return `${ this.entityKey }_list_empty_help_message`
  }

  async created():Promise<void> {
    if (typeof this.items === 'function') {
      this.data = await this.items()
    }

    if (this.items instanceof Promise) {
      this.data = await this.items
    }
  }
}
